import { useCallback, useRef, useState } from 'react';
import { View } from 'react-native';
import { useHover } from 'react-native-web-hooks';

import { AlertButtonProps } from '@components/alert/types';
import { useAlertScaleFont } from './useAlertScaleFont';

export type UseManageAlertButtonParams = Pick<AlertButtonProps, 'b' | 'hide'>;

export const useManageAlertButton = ({ b, hide }: UseManageAlertButtonParams) => {
  const ref = useRef<View>(null);

  const { scale } = useAlertScaleFont();

  const hovered = useHover(ref);
  const [pressed, setPressed] = useState(false);

  const handlePress = useCallback(() => {
    hide();
    if (b.onPress) {
      b.onPress();
    }
  }, [hide, b]);

  const handlePressIn = useCallback(() => {
    setPressed(true);
  }, []);

  const handlePressOut = useCallback(() => {
    setPressed(false);
  }, []);

  return { ref, scale, hovered, pressed, handlePress, handlePressIn, handlePressOut };
};
